import { Component, OnInit } from '@angular/core';
import * as fromConfig from 'src/app/root-store/config/selectors/config.selectors';
import { updateCommentToWorkflow } from 'src/app/root-store/workflow/workflow.actions';
import { Store, select } from '@ngrx/store';
import { Theme } from 'src/app/core/models/theme.model';
import { Input } from '@angular/core';
@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
})
export class CommentComponent implements OnInit {
  commentOpen = false;
  config: Theme;

  @Input() comments: any[];
  comment = '';
  editIdx = null;
  showAction = false;
  constructor(private store: Store) {}
  ngOnInit(): void {
    this.store.pipe(select(fromConfig.getConfig)).subscribe((config) => {
      this.config = config;
      this.chatBtnClass();
      this.commentBoxClass();
    });
  }
  showCommentBox() {
    this.commentOpen = !this.commentOpen;
    this.commentBoxClass();
  }
  addComment() {
    if (this.comment !== '') {
      this.comments.push(this.comment);
      this.comment = '';
      this.syncCommentToStore();
    }
  }
  updateCommnet() {
    if (this.comment !== '') {
      this.comments[this.editIdx] = this.comment;
      this.comment = '';
      this.editIdx = null;
      this.syncCommentToStore();
    }
  }
  storeComment() {
    if (this.editIdx !== null) return this.updateCommnet();
    this.addComment();
  }
  editComment(idx) {
    this.editIdx = idx;
    this.comment = this.comments[idx];
  }
  deleteComment(idx) {
    this.comments.splice(idx, 1);
    this.syncCommentToStore();
  }

  syncCommentToStore() {
    this.store.dispatch(
      updateCommentToWorkflow({ comment: JSON.stringify(this.comments) })
    );
  }

  handleHover() {
    this.showAction = true;
  }
  handleBlur() {
    this.showAction = false;
  }
  chatBtnClass() {
    if (this.config.direction == 'rtl') return { 'comment-rtl': true };
    return { 'comment-ltr': true };
  }
  commentBoxClass() {
    if (this.config.direction == 'rtl')
      return { 'left-comment': true, open: this.commentOpen };
    return { 'right-comment': true, open: this.commentOpen };
  }
}
